import { z } from "zod";

export const PUBLIC_LOCALES = [
  "en",
  "ar",
  "fr",
  "zh-CN",
  "es",
  "de",
  "ru",
  "hi",
  "id",
  "ms",
] as const;

export const publicLocaleSchema = z.enum(PUBLIC_LOCALES);
export type PublicLocale = z.infer<typeof publicLocaleSchema>;

export const DEFAULT_PUBLIC_LOCALE: PublicLocale = "en";

export const LOCALE_FIELD_SUFFIX: Record<PublicLocale, string> = {
  en: "En",
  ar: "Ar",
  fr: "Fr",
  "zh-CN": "ZhCn",
  es: "Es",
  de: "De",
  ru: "Ru",
  hi: "Hi",
  id: "Id",
  ms: "Ms",
};

export function isPublicLocale(value: unknown): value is PublicLocale {
  return typeof value === "string" && (PUBLIC_LOCALES as readonly string[]).includes(value);
}

export function normalizePublicLocale(value: unknown): PublicLocale | null {
  if (value === "zh-cn" || value === "zh-hans-cn") return "zh-CN";
  if (isPublicLocale(value)) return value;
  if (typeof value !== "string") return null;
  const lower = value.toLowerCase();
  if (lower === "zh" || lower === "zh-cn" || lower === "zh-hans-cn") return "zh-CN";
  const base = lower.split("-")[0];
  return isPublicLocale(base) ? base : null;
}
